import { NavLink, useLocation } from "react-router-dom";
import SubRouter from "../../../router/subRouter";
import { CONFIGURATION_ROUTER_URL, FACULTY_ROUTER_URL, STAFF_PREPEND, STAFF_ROUTER_URL, STUDENT_ROUTER_URL } from "../../../constants/routerUrl";
import { useEffect, useState } from "react";
import { UserTypes } from "../../../models/dashboard/adminDashboard";
import { ISubMenu } from "../../../models/common/ISubMenu";
import { getCurrentUserData } from "../../../action/user/userProfileActionCreator";
import { connect } from "react-redux";
import { UserRole } from "../../../constants/RoleEnum";

const AdminUserSubMenu = (props: ISubMenu) => {
    const { currentRole } = props;
    const location = useLocation();
    const userRole = location.state?.userRole;

    const isActive = (path: string) => location.pathname.startsWith(path);

    return (userRole &&
        (<div className="admin-wrap">
            <div className="adminnav">
                {userRole === UserTypes.Staff && (currentRole === UserRole.SuperAdmin || currentRole === UserRole.DepartmentAdmin) && (
                    <ul>
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.BUTTON_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Button
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.WIDGET_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Widget
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.APPS_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Apps
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.NOTIFICATION_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Notifications
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.TECHNOLOGY_RESOURCE_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Technology Resource
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.MEDIA_CONTENT_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Media Content
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                to={STAFF_ROUTER_URL.SNAPSHOT_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Snapshots
                            </NavLink>
                        </li>
                        {currentRole === UserRole.DepartmentAdmin && (
                            <>
                                <li>
                                    <NavLink
                                        to={STAFF_ROUTER_URL.TRAINING_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Training
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={STAFF_ROUTER_URL.REPORT_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Reports
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={STAFF_ROUTER_URL.DEPARTMENT_RESOURCE_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Department Resource
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={STAFF_ROUTER_URL.TRAINING_HELP_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Training Help
                                    </NavLink>
                                </li>
                            </>
                        )}
                    </ul>
                )}
                {userRole === UserTypes.Student && (currentRole === UserRole.SuperAdmin || currentRole === UserRole.CollegeAdmin) && (
                    <ul>
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.BUTTON_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Button
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.WIDGET_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Widget
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.APPS_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Apps
                            </NavLink>
                        </li>
                        {/* <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.STUDENT_RESOURCE_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Student Resource
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.STUDENT_HELP_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Student Help
                            </NavLink>
                        </li> */}
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.NOTIFICATION_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Notifications
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to={STUDENT_ROUTER_URL.SNAPSHOT_PRIORITY}
                                state={{ userRole: userRole }}
                            >
                                Snapshots
                            </NavLink>
                        </li>
                    </ul>
                )}
                {userRole === UserTypes.Faculty && (currentRole === UserRole.SuperAdmin || currentRole === UserRole.CollegeAdmin || currentRole === UserRole.DepartmentAdmin) && (
                    currentRole === UserRole.DepartmentAdmin
                        ?
                        <>
                            <ul>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.REPORT_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Report
                                    </NavLink>
                                </li>
                            </ul>
                        </>
                        :
                        <>
                            <ul>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.BUTTON_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Button
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.WIDGET_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Widget
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.APPS_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Apps
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.NOTIFICATION_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Notifications
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={FACULTY_ROUTER_URL.SNAPSHOT_PRIORITY}
                                        state={{ userRole: userRole }}
                                    >
                                        Snapshots
                                    </NavLink>
                                </li>
                            </ul>
                        </>
                )}
            </div>
            <SubRouter />
        </div>)
    );
};

function mapStateToProps(state: any) {
    return {
        currentRole: state.userDetails.userProfileData?.currentRole,
    };
}

export default connect(mapStateToProps, null)(AdminUserSubMenu);
